import React, { useState, useEffect } from "react";
import axios from "axios";
import { Snackbar, TextField, Button, Typography, Select, MenuItem, FormControl, IconButton, Collapse } from "@mui/material";
import HelpIcon from '@mui/icons-material/Help';
import "../shared/modern-ui.css";

const UpdateUserInfo = () => {
    const [userInfo, setUserInfo] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        program: "",
        user_type: "",
        graduation_document: null
    });
    const lisans = [
    "Acıbadem Mehmet Ali Aydınlar Üniversitesi - Biyomedikal Mühendisliği",
    "Afyon Kocatepe Üniversitesi - Biyomedikal Mühendisliği",
    "Ankara Üniversitesi - Biyomedikal Mühendisliği",
    "Bahçeşehir Üniversitesi - Biyomedikal Mühendisliği",
    "Başkent Üniversitesi - Biyomedikal Mühendisliği",
    "Beykent Üniversitesi - Biyomedikal Mühendisliği",
    "Biruni Üniversitesi - Biyomedikal Mühendisliği",
    "Çukurova Üniversitesi - Biyomedikal Mühendisliği",
    "Doğu Akdeniz Üniversitesi - Biyomedikal Mühendisliği",
    "Düzce Üniversitesi - Biyomedikal Mühendisliği",
    "Erciyes Üniversitesi - Biyomedikal Mühendisliği",
    "Fatih Sultan Mehmet Vakıf Üniversitesi - Biyomedikal Mühendisliği",
    "Işık Üniversitesi - Biyomedikal Mühendisliği",
    "İnönü Üniversitesi - Biyomedikal Mühendisliği",
    "İskenderun Teknik Üniversitesi - Biyomedikal Mühendisliği",
    "İstanbul Arel Üniversitesi - Biyomedikal Mühendisliği",
    "İstanbul Medipol Üniversitesi - Biyomedikal Mühendisliği",
    "İstanbul Yeni Yüzyıl Üniversitesi - Biyomedikal Mühendisliği",
    "İstinye Üniversitesi - Biyomedikal Mühendisliği",
    "İzmir Bakırçay Üniversitesi - Biyomedikal Mühendisliği",
    "İzmir Demokrasi Üniversitesi - Biyomedikal Mühendisliği",
    "İzmir Ekonomi Üniversitesi - Biyomedikal Mühendisliği",
    "İzmir Katip Çelebi Üniversitesi - Biyomedikal Mühendisliği",
    "Karabük Üniversitesi - Biyomedikal Mühendisliği",
    "Kastamonu Üniversitesi - Biyomedikal Mühendisliği",
    "Kocaeli Üniversitesi - Biyomedikal Mühendisliği",
    "Kocaeli Üniversitesi (M.T.O.K) - Biyomedikal Mühendisliği",
    "Pamukkale Üniversitesi - Biyomedikal Mühendisliği",
    "Samsun Üniversitesi - Biyomedikal Mühendisliği",
    "Tekirdağ Namık Kemal Üniversitesi - Biyomedikal Mühendisliği",
    "TOBB Ekonomi Ve Teknoloji Üniversitesi - Biyomedikal Mühendisliği",
    "Uluslararası Kıbrıs Üniversitesi - Biyomedikal Mühendisliği",
    "Yakın Doğu Üniversitesi - Biyomedikal Mühendisliği",
    "Yeditepe Üniversitesi - Biyomedikal Mühendisliği",
    "Yıldız Teknik Üniversitesi - Biyomedikal Mühendisliği",
    "Zonguldak Bülent Ecevit Üniversitesi - Biyomedikal Mühendisliği",
  ];

    const [selectedFile, setSelectedFile] = useState(null);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [openHelp, setOpenHelp] = useState(false); // Yeni eklenen state

    // Kullanıcı bilgilerini çek
    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const res = await axios.get("https://kariyer.biyomed.net/api/users/getOne", {
                    withCredentials: true,
                });
                if (res.data.user) {
                    setUserInfo(res.data.user);
                }
            } catch (error) {
                console.error("Kullanıcı bilgileri alınırken hata oluştu:", error);
                setSnackbarMessage("Kullanıcı bilgileri alınırken hata oluştu!");
                setOpenSnackbar(true);
            }
        };

        fetchUserInfo();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUserInfo({
            ...userInfo,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (file.type !== "application/pdf") {
            setSnackbarMessage("Sadece PDF dosyaları yüklenebilir!");
            setOpenSnackbar(true);
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            setSnackbarMessage("Dosya boyutu 5MB'ı geçemez!");
            setOpenSnackbar(true);
            return;
        }

        setSelectedFile(file);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!userInfo.first_name || !userInfo.last_name || !userInfo.email || !userInfo.phone) {
            setSnackbarMessage("Tüm alanlar zorunludur!");
            setOpenSnackbar(true);
            return;
        }

        const formData = new FormData();
        formData.append("first_name", userInfo.first_name);
        formData.append("last_name", userInfo.last_name);
        formData.append("email", userInfo.email);
        formData.append("phone", userInfo.phone);
        formData.append("program", userInfo.program);

        if (selectedFile) {
            formData.append("graduation_document", selectedFile);
        }

        try {
            await axios.put("https://kariyer.biyomed.net/api/register/updateUserInfo", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                withCredentials: true,
            });

            setSnackbarMessage("Kullanıcı bilgileri başarıyla güncellendi!");
            setOpenSnackbar(true);
        } catch (error) {
            setSnackbarMessage("Bir hata oluştu!");
            setOpenSnackbar(true);
            console.error(error);
        }
    };

    return (
        <div className="bm-page">
            <div className="bm-container bm-container--narrow">
                <div className="bm-page-head">
                    <h1 className="bm-page-title">Kayıt Bilgilerim</h1>
                    <p className="bm-page-sub">
                        Kayıt sırasında girdiğiniz bilgiler. Kilitli alanlar için bizimle iletişime geçebilirsiniz.
                    </p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="bm-card">
                        <div className="bm-card-head">
                            <span className="bm-card-badge"><i className="fa fa-user" /></span>
                            <h3>Kişisel Bilgiler</h3>
                        </div>

                        <div className="bm-card-body">
                            <div className="bm-form-grid">
                                <div className="bm-field">
                                    <TextField fullWidth size="small" label="İsim" name="first_name" value={userInfo.first_name} onChange={handleInputChange} disabled />
                                </div>
                                <div className="bm-field">
                                    <TextField fullWidth size="small" label="Soyisim" name="last_name" value={userInfo.last_name} onChange={handleInputChange} disabled />
                                </div>
                                <div className="bm-field bm-field--wide">
                                    <TextField fullWidth size="small" label="Email" name="email" type="email" value={userInfo.email} onChange={handleInputChange} disabled required />
                                </div>
                                <div className="bm-field bm-field--wide">
                                    <TextField fullWidth size="small" label="Telefon" name="phone" value={userInfo.phone} onChange={handleInputChange} required helperText="Güncelleyebileceğiniz tek alan" />
                                </div>
                                <div className="bm-field bm-field--wide">
                                    <label className="bm-label">Program</label>
                                    <FormControl fullWidth required size="small">
                                        <Select
                                            name="program"
                                            disabled
                                            displayEmpty
                                            value={userInfo.program || ""}
                                            onChange={(e) => handleInputChange(e, "user")}
                                        >
                                            {lisans.map((item, index)=>(
                                                <MenuItem key={index} value={item}>{item}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>

                            {/* Mezuniyet Belgesi Yükleme Alanı */}
                            <div className="bm-section" style={{ marginTop: 28 }}>
                                <h4 className="bm-section-title">Mezuniyet Belgesi</h4>
                                <div className={`bm-upload${userInfo.graduation_document ? " bm-upload--filled" : ""}`}>
                                    <span className="bm-upload-icon">
                                        <i className={`fa ${userInfo.graduation_document ? "fa-check" : "fa-file-pdf-o"}`} />
                                    </span>
                                    <span className="bm-upload-text">
                                        <span className="bm-upload-title">
                                            {userInfo.graduation_document ? "Yüklü dosya mevcut" : "Dosya mevcut değil"}
                                        </span>
                                        <span className="bm-upload-sub">
                                            {selectedFile ? `Seçilen dosya: ${selectedFile.name}` : "PDF · en fazla 5MB · değişiklik için destek ekibiyle görüşün"}
                                        </span>
                                    </span>
                                    <input disabled type="file" accept="application/pdf" onChange={handleFileChange} />
                                </div>
                            </div>
                        </div>

                        <div className="bm-form-footer bm-form-footer--end">
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                sx={{ textTransform: "none", borderRadius: "10px", px: 3, py: 1.1, fontWeight: 600 }}
                            >
                                Güncelle
                            </Button>
                        </div>
                    </div>
                </form>

                {/* Ana Mesaj */}
                <div style={{ textAlign: "center", marginTop: 28 }}>
                    <Typography component="span" sx={{ color: "#334155", fontSize: "15px", fontWeight: 600 }}>
                        Neden her şeyi güncelleyemiyorum?
                    </Typography>
                    <IconButton onClick={() => setOpenHelp(!openHelp)} sx={{ ml: 0.5 }} size="small">
                        <HelpIcon color="disabled" fontSize="small" />
                    </IconButton>

                    {/* Yardım Açıklaması */}
                    <Collapse in={openHelp}>
                        <div className="bm-note" style={{ marginTop: 12, textAlign: "left" }}>
                            <i className="fa fa-info-circle" style={{ marginTop: 2 }} />
                            <span>
                                Bu alanlar genellikle admin veya sistem yöneticisi tarafından düzenlenebilir.
                                Bizimle iletişime geçerek bu alanlarda değişiklik yapılmasını talep edebilirsiniz.
                            </span>
                        </div>
                    </Collapse>
                </div>

                {/* Snackbar for error/success messages */}
                <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={() => setOpenSnackbar(false)} message={snackbarMessage} />
            </div>
        </div>
    );
};

export default UpdateUserInfo;
